<div class="container mt-4">
  <!-- Tiêu đề với Biểu tượng -->
  <h1 class="h3 mb-2 text-gray-800">
    <i class="fas fa-truck mr-2"></i> Nhà cung cấp
  </h1>

  <!-- Mô tả dưới tiêu đề -->
  <p class="lead mb-4">
    Quản lý và xem thông tin về các nhà cung cấp của bạn. Sử dụng các tab điều hướng để chuyển đổi giữa các chế độ xem khác nhau, chẳng hạn như tổng quan chi tiết, danh sách nhà cung cấp và hướng dẫn sử dụng. Nút "Thêm Nhà Cung Cấp" cho phép bạn thêm nhà cung cấp mới vào hệ thống.
  </p>

  <!-- Tab Điều Hướng -->
  <ul class="nav nav-tabs">
    <li class="nav-item">
      <a class="nav-link active" data-toggle="tab" href="#List">
        <i class="fas fa-list mr-2"></i> Danh sách
      </a>
    </li>
    <li class="nav-item">
      <a class="nav-link" data-toggle="tab" href="#UserManual">
        <i class="fas fa-book mr-2"></i> Hướng dẫn sử dụng
      </a>
    </li>
  </ul>

  <!-- Nội dung Tab -->
  <div class="tab-content">
    <!-- Nội dung tab Danh sách -->
    <div id="List" class="tab-pane fade show active custom-tab-pane">
      <div class="container-fluid">
        <!-- Nút Thêm Nhà Cung Cấp -->
        <button class="btn btn-outline-primary mb-3" (click)="openAddDialog()">Thêm Nhà Cung Cấp</button>
        <button
          href="#"
          role="button"
          class="btn btn-outline-warning btn-icon-split"
          (click)="loadVendors()"
        >
          <span class="icon text-warning">
            <i class="fas fa-redo"></i>
          </span>
          <span class="text">Tải lại</span>
        </button>
        <!-- Bảng Nhà Cung Cấp sử dụng ngx-datatable -->
        <div class="card mb-4">
          <div class="card-body">
            <div *ngIf="loadingIndicator; else loaded">
              <div class="d-flex justify-content-center">
                <div class="spinner-border text-primary" role="status">
                  <span class="sr-only">Đang tải...</span>
                </div>
              </div>
            </div>
    
            <ng-template #loaded>
            <ngx-datatable
              class="bootstrap"
              [rows]="vendors"
              [loadingIndicator]="loadingIndicator"
              [columnMode]="'force'"
              [headerHeight]="50"
              [footerHeight]="50"
              [rowHeight]="'auto'"
              [limit]="10">
              <ngx-datatable-column name="Hình thu nhỏ">
                <ng-template ngx-datatable-cell-template let-row="row">
                  <!-- Tạo màu nền ngẫu nhiên -->
                  <div [style.background-color]="blue" 
                       style="width: 50px; height: 50px; display: flex; align-items: center; justify-content: center; border-radius: 50%; color: white; font-weight: bold;">
                    {{ row.name ? row.name.charAt(0).toUpperCase() : '' }}
                  </div>
                </ng-template>
              </ngx-datatable-column>
              <ngx-datatable-column name="Tên" prop="name"></ngx-datatable-column>
              <ngx-datatable-column name="Địa chỉ" prop="address"></ngx-datatable-column>
              <ngx-datatable-column name="Số điện thoại" prop="phone"></ngx-datatable-column>
              <ngx-datatable-column name="Email" prop="email"></ngx-datatable-column>
              <ngx-datatable-column name="Ghi chú" prop="notes"></ngx-datatable-column>
              <ngx-datatable-column name="Hành động">
                <ng-template let-row="row" ngx-datatable-cell-template>
                  
                    <button type="button" class="btn btn-outline-primary dropdown-toggle btn-sm" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                        Hành động
                    </button>
                    <div class="dropdown-menu">
                        <a class="dropdown-item"  (click)="openEditDialog(row)">
                            <i class="fas fa-edit"></i> Chỉnh sửa
                        </a>
                        <a class="dropdown-item"  (click)="deleteVendor(row.id)">
                            <i class="fas fa-trash-alt"></i> Xóa
                        </a>
                    </div>
                </ng-template>
              </ngx-datatable-column>
            </ngx-datatable>
            </ng-template>
          </div>
        </div>
      </div>
    </div>

    <!-- Nội dung tab Hướng dẫn sử dụng -->
    <div id="UserManual" class="tab-pane custom-tab-pane">
      <!-- Nội dung Hướng dẫn sử dụng tại đây -->
      <div>
          <div  [innerHTML]="markdownContent"></div>
      </div>
    </div>

  </div>
</div>
